import React, { useEffect } from "react";
import { ToastContainer, toast, Slide } from "react-toastify";

const Toast = () => {
    useEffect(() => {
        let toastData = window.sessionStorage.getItem("toast");

        if(toastData) {
            let toastify = JSON.parse(toastData);
            toast[toastify.type](toastify.text);
            window.sessionStorage.removeItem("toast");
        }
    }, []);

    return <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Slide}
    />;
};

export default Toast;